import React, { useState, useEffect, useCallback } from "react";
import DigitalContractTemplatesDetailView from "./digital-contract-template-detail.view"
import DigitalContractTemplatesDetailAdd from "./digital-contract-template-add.view"
import DigitalContractTemplatesVariableView from "./digital-contract-template-variables.view";
import TemplateAdministrationDisableView from "./digital-contract-template-delete.view"
import DigitalContractTemplatePdfView from "./digital-contract-template-pdf.view"
import { SimpleLoading } from "../../../pures";
import { TemplateService } from "../../../../services";
import { useTranslation } from "react-i18next";

const TemplatesConfigurationsView = ({
    selectedTemplate,
    hideShowDetails,
    nameComponentTemplate,
    token,
    rolesBySignatureProfile,
    setHeaderTitleinDetail,
    validators,
    forceRefresh,
    options,
    getVariablesFromDoc,
    getTemplatebyPath,
    showLoadingRequesting,
    showCompletedRequesting,
    showErrorRequesting,
    toggleLoadingRequesting,
    toggleCompletedRequesting,
    toggleErrorRequesting,
    clientId,
    formatVariables,
    message,
    clientTemplates,
    selectedCompany,
    history
}) => {


    const [showLoadingRequest, setShowLoadingRequest] = useState(false);
    const [stateNameComponentUser, setStateNameComponentUser] = useState("");
    const [laststateNameComponentUser, setLastStateNameComponentUser] = useState("");
    const [showDetailComponent, setShowComponentDetail] = useState(false);
    const [showCompletedRequest, setShowCompletedRequest] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        setStateNameComponentUser(nameComponentTemplate);
    }, [nameComponentTemplate]);

    const createTemplate = async (companyId, name, description, document) => {
        let nameValid = validators.nameValidator(name);
        if ((name === null && name === "") || nameValid !== "") {
            toggleErrorRequesting(true, t('dialogUpdateUserAddress.errorFirstName'))
            return false;
        }

        let descriptionValid = validators.descriptionValidator(description)
        if (descriptionValid !== "" && description !== "") {
            toggleErrorRequesting(true, t('dialogDeleteSignature.errorCommnets'))
            return false;
        }
        let templateService = new TemplateService(process.env.REACT_APP_MIFIRMA_API);
        let data = new FormData()
        data.append('document', document)
        data.append('clientId', clientId)
        data.append('companyId', companyId)
        data.append('name', name)
        data.append('description', description)

        toggleLoadingRequesting(true);

        try {
            let response = await templateService.createNewTemplate(data, token)
            if (response && response.statusCode === 200) {
                let templates = await templateService.getTemplatebyClientId(clientId, null, token);

                await toggleLoadingRequesting(false);
                await toggleCompletedRequesting(true, '', templates);
                // forceRefresh();
                setTimeout(() => {
                    hideShowDetails();
                }, 4000)
            } else if (response && Number(response.statusCode) < -1) {
                toggleLoadingRequesting(false);
                toggleErrorRequesting(true, response.message);
            } else {
                toggleLoadingRequesting(false);
                toggleErrorRequesting(true);
                setTimeout(() => {
                    hideShowDetails();
                }, 4000)
            }
        } catch (error) {
            toggleLoadingRequesting(false);
            toggleErrorRequesting(true);
            setTimeout(() => {
                hideShowDetails();
            }, 4000)
            return false;
        }

    }

    const updateTemplate = async (templateData) => {
        let nameValid = validators.nameValidator(templateData.name);
        if ((templateData.name === null && templateData.name === "") || nameValid !== "") {
            toggleErrorRequesting(true, t('dialogUpdateUserAddress.errorFirstName'))
            return false;
        }

        let descriptionValid = validators.descriptionValidator(templateData.description)
        if (descriptionValid !== "" && templateData.description !== "") {
            toggleErrorRequesting(true, t('dialogDeleteSignature.errorCommnets'))
            return false;
        }

        let templateService = new TemplateService(process.env.REACT_APP_MIFIRMA_API);
        let data = new FormData()
        data.append('id', templateData.id)
        data.append('document', templateData.document)
        data.append('clientId', clientId)
        data.append('companyId', templateData.companyId)
        data.append('name', templateData.name)
        data.append('description', templateData.description)
        data.append('modificationConfirmed', templateData.isConfirmed)

        toggleLoadingRequesting(true);

        try {
            let response = await templateService.updateTemplate(data, token)
            if (response && response.statusCode === 200) {
                let templates = await templateService.getTemplatebyClientId(clientId, null, token);

                await toggleLoadingRequesting(false);
                await toggleCompletedRequesting(true, '', templates);
                // forceRefresh();
                setTimeout(() => {
                    hideShowDetails();
                }, 4000)
            } else if (response.statusCode === 420) {
                toggleLoadingRequesting(false);
                return response.data;
            } else {
                toggleLoadingRequesting(false);
                toggleErrorRequesting(true);
                setTimeout(() => {
                    hideShowDetails();
                }, 4000)
            }
        } catch (error) {
            toggleLoadingRequesting(false);
            toggleErrorRequesting(true);
            setTimeout(() => {
                hideShowDetails();
            }, 4000)
        }
    }

    const deleteTemplate = async (id, token) => {
        let templateService = new TemplateService(process.env.REACT_APP_MIFIRMA_API);
        toggleLoadingRequesting(true);

        try {
            let response = await templateService.deleteTemplate(id, token)
            if (response && response.statusCode === 200) {
                let templates = await templateService.getTemplatebyClientId(clientId, null, token);

                await toggleLoadingRequesting(false);
                await toggleCompletedRequesting(true, '', templates);
                // forceRefresh();
                setTimeout(() => {
                    hideShowDetails();
                }, 4000)
            } else {
                toggleLoadingRequesting(false);
                toggleErrorRequesting(true);
                setTimeout(() => {
                    hideShowDetails();
                }, 4000)
            }
        } catch (error) {
            toggleLoadingRequesting(false);
            toggleErrorRequesting(true);
            setTimeout(() => {
                hideShowDetails();
            }, 4000)
            return false;
        }

    }
    const getFormatVariables = async () => {
        let templateService = new TemplateService(process.env.REACT_APP_MIFIRMA_API);
        let response = await templateService.getFormatVariables(token);
        setShowLoadingRequest(true);

        setShowLoadingRequest(false);
        return response
    }

    forceRefresh = () => {
        this.setState(({ shouldRefresh }) => ({ shouldRefresh: !shouldRefresh }));
    };

    const editTemplate = async (id) => {
        toggleLoadingRequesting(true);
        //Delete clientContractId from localStorage to avoid call function to update clienContract
        localStorage.removeItem('clientContractId')
        history.push({
            pathname: `/edit-docx/${id}`,
            state: { trackChangesGovo: false, type: "template" },
        });
    }


    const renderComponentUser = useCallback(() => {
        switch (stateNameComponentUser) {
            case t("digitalContractDashboard.templates.routerDisable"):
                return (
                    <TemplateAdministrationDisableView
                        hideShowDetails={hideShowDetails}
                        selectedTemplate={selectedTemplate}
                        token={token}
                        deleteTemplate={deleteTemplate}
                        setHeaderTitleinDetail={setHeaderTitleinDetail}
                        setStateNameComponentUser={setStateNameComponentUser}
                        laststateNameComponentUser={laststateNameComponentUser}
                        toggleLoadingRequesting={toggleLoadingRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}
                        toggleErrorRequesting={toggleErrorRequesting}
                        showLoadingRequesting={showLoadingRequesting}
                        showErrorRequesting={showErrorRequesting}
                        showCompletedRequesting={showCompletedRequesting}
                        message={message}

                    />
                );
            case t("digitalContractDashboard.templates.routerAdd"):
                return (
                    <DigitalContractTemplatesDetailAdd
                        hideShowDetails={hideShowDetails}
                        options={options.filter(option => option.id !== "1")}
                        getVariablesFromDoc={getVariablesFromDoc}
                        showLoadingRequesting={showLoadingRequesting}
                        showCompletedRequesting={showCompletedRequesting}
                        message={message}
                        showErrorRequesting={showErrorRequesting}
                        toggleLoadingRequesting={toggleLoadingRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}
                        toggleErrorRequesting={toggleErrorRequesting}
                        createTemplate={createTemplate}
                        selectedCompanies={selectedCompany}
                        setHeaderTitleinDetail={setHeaderTitleinDetail}
                        setStateNameComponentUser={setStateNameComponentUser}
                        setLastStateNameComponentUser={setLastStateNameComponentUser}
                    />
                );
            case t("procedureAdministrationView.details"):
                return (
                    <DigitalContractTemplatesDetailView
                        hideShowDetails={hideShowDetails}
                        options={options}
                        getVariablesFromDoc={getVariablesFromDoc}
                        getTemplatebyPath={getTemplatebyPath}
                        selectedTemplate={selectedTemplate}
                        setHeaderTitleinDetail={setHeaderTitleinDetail}
                        setStateNameComponentUser={setStateNameComponentUser}
                        updateTemplate={updateTemplate}
                        toggleLoadingRequesting={toggleLoadingRequesting}
                        toggleCompletedRequesting={toggleCompletedRequesting}
                        toggleErrorRequesting={toggleErrorRequesting}
                        showLoadingRequesting={showLoadingRequesting}
                        showErrorRequesting={showErrorRequesting}
                        showCompletedRequesting={showCompletedRequesting}
                        message={message}
                        selectedCompany={selectedCompany}
                        setLastStateNameComponentUser={setLastStateNameComponentUser}
                        editTemplate={editTemplate}
                    />
                );
            case "Variables":
                return (
                    <DigitalContractTemplatesVariableView
                        hideShowDetails={hideShowDetails}
                        options={options}
                        selectedTemplate={selectedTemplate}
                        getFormatVariables={getFormatVariables}
                        formatVariables={formatVariables}
                        selectedCompany={selectedCompany}
                        setHeaderTitleinDetail={setHeaderTitleinDetail}
                        setStateNameComponentUser={setStateNameComponentUser}
                        laststateNameComponentUser={laststateNameComponentUser}
                    />
                );
            case "Pdf":
                //TERMINAR AQUI
                return (
                    <DigitalContractTemplatePdfView
                        hideShowDetails={hideShowDetails}
                        options={options}
                        selectedTemplate={selectedTemplate}
                        selectedCompany={selectedCompany}
                        deleteTemplate={deleteTemplate}
                        setHeaderTitleinDetail={setHeaderTitleinDetail}
                        setStateNameComponentUser={setStateNameComponentUser}
                        laststateNameComponentUser={laststateNameComponentUser}
                    />
                );
            default:
                return;
        }
    }, [
        stateNameComponentUser,
        selectedTemplate,
        hideShowDetails,
        setHeaderTitleinDetail,
        token,
        rolesBySignatureProfile,
        showLoadingRequest,
        showDetailComponent,
        validators,
        showCompletedRequest,
    ]);

    return <>{renderComponentUser()}</>;
};

export default TemplatesConfigurationsView;
